/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mAirdropRankItem.vue?vue&type=template&id=939a9abe&scoped=true"
import script from "./mAirdropRankItem.vue?vue&type=script&lang=js"
export * from "./mAirdropRankItem.vue?vue&type=script&lang=js"
import style0 from "./mAirdropRankItem.vue?vue&type=style&index=0&id=939a9abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939a9abe",
  null
  
)

export default component.exports